module.exports = __webpack_public_path__ + "img/vegetable-eggplant-350x184.9a59b6f0.jpg";